import React from 'react';

const Introduction: React.FC = () => {
  return (
    <div>
      <h1 className="govuk-heading-l">Having conversations</h1>
      <p className="govuk-body">
        Having conversations about your Advance Care Plan, health and social
        care wishes is important. If you have had a conversation with a loved
        one, your GP or any other health or a social care professional please
        provide their details below.
      </p>
      <p className="govuk-body">
        If there is anyone who you would not like your Advance Care Plan, health
        and social care wishes to be discussed now or in the future please also
        provide their details.
      </p>
      <p className="govuk-body">
        When you have conversations about your Advance Care Plan, health and
        social care wishes in the future, please let us know when these
        conversations take place and we will add the relevant information to
        your Advance Care Plan
      </p>
    </div>
  );
};

export default Introduction;
